<nz-collapse nzGhost>
  <nz-collapse-panel
    nzCollapsible="icon"
    [nzHeader]="'general.title' | translate"
    [nzActive]="active"
    [nzCollapsible]="disabled ? 'disabled' : undefined"
  >
    <!-- Acquired At -->
    <nz-form-item>
      <nz-form-label
        class="quali-form-label"
        nzNoColon
        [nzRequired]="acquiredAtFormControl.hasValidator(Validators.required)"
      >
        {{ 'general.acquired_at' | translate }}
      </nz-form-label>
      <nz-form-control [nzValidateStatus]="acquiredAtFormControl" nzHasFeedback>
        <nz-date-picker
          wilsonUseLocalizedDateFormat
          [formControl]="acquiredAtFormControl"
          [nzDisabledDate]="disabledAcquiredAtDates"
          [nzPlaceHolder]="
            hasMixedValues.acquiredAt
              ? ('general.mixed' | translate)
              : ('general.select_date' | translate)
          "
        ></nz-date-picker>
      </nz-form-control>
    </nz-form-item>

    <!-- Valid From -->
    <nz-form-item>
      <nz-form-label
        class="quali-form-label"
        nzNoColon
        [nzRequired]="validFromFormControl.hasValidator(Validators.required)"
      >
        {{ 'general.valid_from' | translate }}
      </nz-form-label>
      <nz-form-control [nzValidateStatus]="validFromFormControl" nzHasFeedback>
        <nz-date-picker
          wilsonUseLocalizedDateFormat
          [formControl]="validFromFormControl"
          [nzDisabledDate]="disabledValidFromDates"
          [nzPlaceHolder]="
            hasMixedValues.validFrom
              ? ('general.mixed' | translate)
              : ('general.select_date' | translate)
          "
        ></nz-date-picker>
      </nz-form-control>
    </nz-form-item>

    <!-- Valid Until + Infinite -->
    <div nz-row [nzGutter]="16" nzAlign="bottom">
      <div nz-col nzSpan="21">
        <nz-form-item>
          <nz-form-label
            class="quali-form-label"
            nzNoColon
            [nzRequired]="
              validUntilFormControl.hasValidator(Validators.required)
            "
          >
            {{ 'general.valid_until' | translate }}
          </nz-form-label>
          <nz-form-control
            [nzValidateStatus]="validUntilFormControl"
            nzHasFeedback
          >
            @if (!infiniteValidFormControl?.value) {
              <nz-date-picker
                wilsonUseLocalizedDateFormat
                [formControl]="validUntilFormControl"
                [nzDisabledDate]="disabledValidUntilDates"
                [nzPlaceHolder]="
                  hasMixedValues.validTill
                    ? ('general.mixed' | translate)
                    : ('general.select_date' | translate)
                "
              ></nz-date-picker>
            } @else {
              <input
                nz-input
                [value]="'∞'"
                disabled
                style="cursor: not-allowed"
              />
            }
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSpan="3">
        <nz-form-item>
          <nz-form-label class="quali-form-label" nzNoColon>
            {{ 'general.infinite' | translate }}
          </nz-form-label>
          <nz-form-control>
            <nz-switch [formControl]="infiniteValidFormControl"></nz-switch>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <!-- Confirmed By Employee -->
    <nz-form-item>
      <nz-form-label class="quali-form-label" nzNoColon>
        {{ 'qualifications.create.confirmed_by_employee' | translate }}
      </nz-form-label>
      <nz-form-control>
        <nz-select
          [formControl]="confirmedByEmployeeFormControl"
          [nzPlaceHolder]="
            hasMixedValues.confirmedByUser
              ? ('general.mixed' | translate)
              : ('general.select_date' | translate)
          "
        >
          <nz-option
            [nzValue]="false"
            [nzLabel]="'page.qualifications.not_confirmed' | translate"
          ></nz-option>
          <nz-option
            [nzValue]="true"
            [nzLabel]="'page.qualifications.confirmed' | translate"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </nz-collapse-panel>
</nz-collapse>
